import PropTypes from "prop-types";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";

import * as Styles from "./giftWithPurchaseInfo/style.module.scss";

export const GIFT_INFO_TITLE = {
  DEFAULT: (amount) => `Spend $${amount}+, Get a Free Gift`,
  GIFT: (amount) => `Spend $${amount}+,`,
};

export const GIFT_INFO_SUBTITLE = {
  DEFAULT: "LIMITED GIFTS AVAILABLE",
  GIFT: "Get this Item for FREE",
};

function GiftWithPurchaseInfo({ isGiftProduct, minimumPurchaseAmount }) {
  return (
    <div
      className={`${Styles.giftWithPurchaseInfoContainerContent} ${
        isGiftProduct ? Styles.containerMargin : ""
      }`}
    >
      <div
        className={`${Styles.giftWithPurchaseInfoContainerContentTitle} ${
          !isGiftProduct ? Styles.contentPadding : ""
        }`}
      >
        <p>
          {isGiftProduct
            ? GIFT_INFO_TITLE.GIFT(minimumPurchaseAmount)
            : GIFT_INFO_TITLE.DEFAULT(minimumPurchaseAmount)}
        </p>
      </div>
      <div
        className={`${Styles.giftWithPurchaseInfoContainerContentSubtitle} ${
          !isGiftProduct ? Styles.contentSubtitle : ""
        }`}
      >
        <p>{isGiftProduct ? GIFT_INFO_SUBTITLE.GIFT : GIFT_INFO_SUBTITLE.DEFAULT}</p>
      </div>
    </div>
  );
}

GiftWithPurchaseInfo.propTypes = {
  isGiftProduct: PropTypes.bool.isRequired,
  minimumPurchaseAmount: PropTypes.number.isRequired,
};

export default withALErrorBoundary({
  name: "GiftWithPurchaseInfo",
  priority: "P1",
})(GiftWithPurchaseInfo);
